import { FaTrash } from "react-icons/fa";
import "rc-slider/assets/index.css";
import Select from "react-select";
import Creatable from "react-select/creatable";
import { connection } from "utils/apiConnection.ts";
import { useState, useEffect } from "react";
import { retry } from "async";
function Filter({ filterInputs, setFilterInputs, search, resetFilters }) {
  const [marketer, setMarketer] = useState([
    //{ value: "create", label: "بازاریاب جدید" },
    // { value: " 0", label: "aبازاریاب" },
    // { value: "1", label: "bبازاریاب" },
    // { value: "2 ", label: "cبازاریاب " },
    // { value: "3 ", label: " dبازاریاب " },
  ]);
  useEffect(() => {
    connection("api/Find_users").then((data) => {
      setMarketer([
        ...data.map((value) => {
          return {
            value: value.id,
            label: value.fullname,
            // phoneNumber: value.mobile,
          };
          // ...data,
        }),
      ]);
    });
  }, []);

  return (
    <>
      <div
        className="modal fade"
        id="filterModal"
        aria-labelledby="filterModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title color-green" id="Label">
                فیلتر کسب و کار
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="row m-1">
                <div className="col-4">
                  <label htmlFor="titleTour" className="form-label">
                    عنوان:
                  </label>
                </div>
                <div className="col-8">
                  <input
                    type="text"
                    id="titleTour"
                    className="form-control"
                    name="title"
                    value={filterInputs.title}
                    onChange={(e) => {
                      setFilterInputs({
                        ...filterInputs,
                        title: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="row m-1 mt-3">
                <div className="col-4">
                  <label
                    htmlFor="complate_order_count_fromTour"
                    className="form-label"
                  >
                    تعداد سفارشات تحویل شده از :
                  </label>
                </div>
                <div className="col-8">
                  <div className="d-flex">
                    <input
                      type="text"
                      id="complate_order_count_fromTour"
                      className="form-control"
                      name="complate_order_count_from"
                      value={filterInputs.complate_order_count_from}
                      onChange={(e) => {
                        setFilterInputs({
                          ...filterInputs,
                          complate_order_count_from: e.target.value,
                        });
                      }}
                    />
                    <p className=" px-2 m-auto">تا </p>
                    <input
                      type="text"
                      id="complate_order_count_toTour"
                      className="form-control"
                      name="complate_order_count_to"
                      value={filterInputs.complate_order_count_to}
                      onChange={(e) => {
                        setFilterInputs({
                          ...filterInputs,
                          complate_order_count_to: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row m-1 mt-3">
                <div className="col-4">
                  <label
                    htmlFor="active_order_count_fromTour"
                    className="form-label"
                  >
                    تعداد سفارشات فعال از :
                  </label>
                </div>
                <div className="col-8">
                  <div className="d-flex">
                    <input
                      type="text"
                      id="active_order_count_fromTour"
                      className="form-control"
                      name="active_order_count_from"
                      value={filterInputs.active_order_count_from}
                      onChange={(e) => {
                        setFilterInputs({
                          ...filterInputs,
                          active_order_count_from: e.target.value,
                        });
                      }}
                    />
                    <p className=" px-2 m-auto">تا </p>
                    <input
                      type="text"
                      id="active_order_count_toTour"
                      className="form-control"
                      name="active_order_count_to"
                      value={filterInputs.active_order_count_to}
                      onChange={(e) => {
                        setFilterInputs({
                          ...filterInputs,
                          active_order_count_to: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row m-1 mt-3">
                <div className="col-4">
                  <label
                    htmlFor="canceled_order_count_fromTour"
                    className="form-label"
                  >
                    تعداد سفارشات کنسل شده از :
                  </label>
                </div>
                <div className="col-8">
                  <div className="d-flex">
                    <input
                      type="text"
                      id="canceled_order_count_fromTour"
                      className="form-control"
                      name="canceled_order_count_from"
                      value={filterInputs.canceled_order_count_from}
                      onChange={(e) => {
                        setFilterInputs({
                          ...filterInputs,
                          canceled_order_count_from: e.target.value,
                        });
                      }}
                    />
                    <p className=" px-2 m-auto">تا </p>
                    <input
                      type="text"
                      id="canceled_order_count_toTour"
                      className="form-control"
                      name="canceled_order_count_to"
                      value={filterInputs.canceled_order_count_to}
                      onChange={(e) => {
                        setFilterInputs({
                          ...filterInputs,
                          canceled_order_count_to: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row m-1 mt-3">
                <div className="col-4">
                  <label
                    htmlFor="total_saled_amount_fromTour"
                    className="form-label"
                  >
                    مجموع فروش از :
                  </label>
                </div>
                <div className="col-8">
                  <div className="d-flex">
                    <input
                      type="text"
                      id="total_saled_amount_fromTour"
                      className="form-control"
                      name="total_saled_amount_from"
                      value={filterInputs.total_saled_amount_from}
                      onChange={(e) => {
                        setFilterInputs({
                          ...filterInputs,
                          total_saled_amount_from: e.target.value,
                        });
                      }}
                    />
                    <p className=" px-2 m-auto">تا </p>
                    <input
                      type="text"
                      id="total_saled_amount_toTour"
                      className="form-control"
                      name="total_saled_amount_to"
                      value={filterInputs.total_saled_amount_to}
                      onChange={(e) => {
                        setFilterInputs({
                          ...filterInputs,
                          total_saled_amount_to: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row m-1 mt-3">
                <div className="col-4">
                  <label htmlFor="marketer" className="form-label">
                    بازار یاب:
                  </label>
                </div>
                <div className="col-8">
                  <div className=" w-100">
                    <Select
                      id="marketer"
                      options={marketer}
                      placeholder="انتخاب..."
                      value={filterInputs.muid}
                      onChange={(e) => {
                        setFilterInputs((prev) => {
                          return { ...prev, muid: e };
                        });
                      }}
                    ></Select>
                    {/* <input
                      type="text"
                      id="marketer"
                      className="form-control"
                      name="total_saled_amount_from"
                      value={filterInputs.total_saled_amount_from}
                      onChange={(e) => {
                        setFilterInputs({
                          ...filterInputs,
                          total_saled_amount_from: e.target.value,
                        });
                      }}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-evenly align-self-center m-2">
              <button
                type="button"
                className="btn btn-warning px-3 mx-4"
                data-bs-dismiss="modal"
                onClick={resetFilters}
              >
                <FaTrash style={{ color: "white" }} />
              </button>
              <button
                type="button"
                className="btn btn-success px-5 mx-4"
                data-bs-dismiss="modal"
                onClick={search}
              >
                ثبت
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Filter;
